module.exports = Em.Component.extend({
    classNames: ['download-list-item'],

    item: null
})
